const SNAPS_DOMAIN = process.env.NEXT_PUBLIC_SNAPS_CLIENT;
const WEB_DOMAIN = process.env.NEXT_PUBLIC_WEB_CLIENT;

// Computed
const seo = {
	type: 'website',
	locale: 'en_US',
	favicon: `${WEB_DOMAIN}/favicon.png`,
	photo: `${SNAPS_DOMAIN}/api/image?template=app&platform=Blog&url=blog.playbooks.ai&format=png`,
	title: 'Playbooks | Blog',
	description: `Playbooks is an AI-native platform that helps entrepreneurs, business owners, and operators transform ideas into intelligent products. Follow product news, engineering, and updates from the workspace.`,
	keywords: `hybrid source software, developer economy, indie developers, software templates, software partials, software starters, software themes, software apps`,
	card: 'summary',
	siteName: 'Playbooks',
	author: 'Playbooks',
	site: '@playbooks_hq',
	baseUrl: process.env.NEXT_PUBLIC_BLOG_CLIENT,
	robots: 'index,follow',
};
export { seo };
